document.addEventListener('DOMContentLoaded', function () {
  const chatWidget = document.querySelector('[data-chat-widget]');

  function handleBundleScriptAdded() {

    // Add a "load" event listener to the bundle script
    const bundleScript = document.querySelector('#gorgias-chat-bundle');
    bundleScript.addEventListener('load', function () {
      observeChatContainer();
    });

    // Disconnect the observer to stop watching for further changes
    observer.disconnect();
  }

  function observeChatContainer() {
    const chatContainer = document.querySelector('#gorgias-chat-container');
    const containerObserver = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const iframeEl = mutation.target.querySelector('#chat-button');
          if (iframeEl) {

            handleIframeLoad();
          }
        }
      }
    });

    // Define the options for the observer (watch for child list changes)
    const containerObserverOptions = {
      childList: true,
      subtree: true,
    };

    containerObserver.observe(chatContainer, containerObserverOptions);
  }

  function isChatOpen() {
    let chatBox = document.querySelector("#chat-window");
    if (chatBox && chatBox.offsetWidth > 0) {
      return true;
    }
    return false;
  }

  function handleIframeLoad() {
    const iframeEl = document.querySelector('#gorgias-chat-container iframe#chat-button');
    iframeEl.addEventListener('load', function () {

      // check to see if the window is open
      setTimeout(() => {
        if (isChatOpen()) {
          chatWidget.classList.add('chat-widget--close');
        }
        chatWidget.classList.add('appear');
      }, 200);

      // Add a click event listener to the chatWidget
      chatWidget.addEventListener('click', function () {
        // Access the iframe element and simulate a click event
        const iframe = document.querySelector('#gorgias-chat-container iframe#chat-button');
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        const elementInsideIframe = iframeDocument.querySelector('button');

        if (elementInsideIframe) {
          const clickEvent = new Event('click', { bubbles: true });
          elementInsideIframe.dispatchEvent(clickEvent);
        }

        // Toggle a class on chatWidget
        chatWidget.classList.toggle('chat-widget--close');
      });
    });
  }

  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const addedScripts = Array.from(mutation.addedNodes).filter(
          (node) =>
            node.tagName === 'SCRIPT' &&
            node.id === 'gorgias-chat-bundle'
        );

        if (addedScripts.length > 0) {
          handleBundleScriptAdded();
        }
      }
    }
  });

  // Define the options for the observer (watch for child list changes)
  const observerOptions = {
    childList: true,
    subtree: true,
  };

  // Start observing the body element
  observer.observe(document.body, observerOptions);
});
